import { Flex } from "Element/Flex";
import React from "react";
import { StyledHeroText } from "../styled";
import { steps } from "./howTo";
import {
  StepImg,
  StyledHowContainer,
  StyledHowWrapper,
  StyledStepsWrapper,
} from "./styled";

const How = () => {
  return (
    <StyledHowContainer>
      <StyledHowWrapper
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <StyledHeroText style={{ marginTop: 0 }}>
          how do i get this nft ?
        </StyledHeroText>
        <StyledStepsWrapper justifyContent="space-between" width="100%">
          {steps.map((step, idx) => (
            <Flex key={idx} flexDirection="column">
              <StepImg src={step.img} alt="" />
              <p style={{ textAlign: "center", width: 300, margin: "0 auto" }}>
                {step.desc}
              </p>
            </Flex>
          ))}
        </StyledStepsWrapper>
      </StyledHowWrapper>
    </StyledHowContainer>
  );
};

export default How;
